<template>
  <div class="info-wrapper">
    <h2>Personal Information</h2>
    <p>Enter and Update all your Personal Information here.</p>
    <span><strong>Rep Code: </strong> {{ personalInfo.agent_code }}</span>

    <div class="information-form mt-4">
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(updateInfo)">
          <div class="form-group">

          </div>

          <div class="form-group row">
            <span class="col-xxl-4 col-lg-6 col-md-6 mb-3">

               <input-text
               :rules="{ required: true, email: true }"
                labelFor="agent_email"
                labelName="Email Address"
                :vmodel.sync="form.email"
                formGroupClass=""
              />

                <span v-if="showOtpSectionEmail" class="validate-btn col-md-5 col-sm-6 d-flex rep-otp-validation">
                  <a href="#"  class="validate-via-otp-link mt-2" @click.prevent="openOtpModal('email')">
                      TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR EMAIL.
                  </a>
                </span>

        <div v-if="emailMsg" class="contact-message-container form-group">
          <div :class="['validate-message mt-2', emailValidationMessage.type]">
            <div :class="['message-indicator', `${emailValidationMessage.type}-indicator`]"></div>
            <span class="message-text">
              <strong :class="`${emailValidationMessage.type}-text`">{{ emailValidationMessage.title }}</strong> - 
              {{ emailValidationMessage.message }}
            </span>
          </div>
        </div>

            </span>
            <span class="col-xxl-4 col-xlg-4 col-lg-6 col-md-6 mb-3">
              <input-text
              :rules="{ required: true, digits: 10 }"
              labelFor="agent_phone1"
              labelName="Cell Phone"
              :vmodel.sync="form.cell_phone"
              placeholder="Enter Phone 1 (no dashes eg: 123456789)"
              formGroupClass=""
              inputType="number"
              @keypress.native="onlyAllowDigits"
              maxlength="10"
              inputmode="numeric"
             pattern="\d*"
              />

                <span v-if="showOtpSectionPhone" class="validate-btn col-md-5 col-sm-6 d-flex rep-otp-validation" >
                  <a href="#" class="validate-via-otp-link mt-2"  @click.prevent="openOtpModal('phone')">
                      TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR PHONE.
                  </a>
                </span>

                <div v-if="phoneMsg" class="contacts-message-container form-group">
          <div :class="['validate-message mt-2', phoneValidationMessage.type]">
            <div :class="['message-indicator', `${phoneValidationMessage.type}-indicator`]"></div>
            <span class="message-text">
              <strong :class="`${phoneValidationMessage.type}-text`">{{ phoneValidationMessage.title }}</strong> - 
              {{ phoneValidationMessage.message }}
            </span>
          </div>
        </div>

            </span>
          </div>
          
          <div class="form-group row">
            <input-text
              :rules="{ required: true }"
              labelFor="agent_fname"
              labelName="First Name"
              :vmodel.sync="form.first_name"
              formGroupClass="col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-3"
            />

            <input-text
              labelFor="agent_mname"
              labelName="Middle Name "
              :vmodel.sync="form.middle_name"
              formGroupClass="col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-3"
            />

            <input-text
              :rules="{ required: true }"
              labelFor="agent_lname"
              labelName="Last Name"
              :vmodel.sync="form.last_name"
              formGroupClass="col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-3"
            />
        
            <input-text
              :rules="{ required: false, digits: 10, clearoutPhone: true }"
              labelFor="agent_phone2"
              labelName="Telephone "
              :vmodel.sync="form.telephone"
              placeholder="Enter Phone 2 (no dashes eg: 123456789)"
              formGroupClass="col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-3"
              inputType="number"
            />

            <input-text
              labelFor="fax"
              labelName="FAX "
              :vmodel.sync="form.fax"
              placeholder="Enter Fax (no dashes eg: 123456789)"
              formGroupClass="col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-3"
            />
            <input-text
              labelFor="num_800"
              labelName="800 Number "
              :vmodel.sync="form.num_800"
              placeholder="Enter 800 Number (no dashes eg: 123456789)"
              formGroupClass="col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-3"
            />
          </div>

          <div class="clearfix"></div>

          <div class="form-group row">
            <input-image
              :rules="{ required: false }"
              @deleteImage="
                deleteImage('personal', () => removeImageRef('personal'))
              "
              ref="image"
              labelFor="image"
              labelName="Personal Photo Image"
              :vmodel.sync="image"
              formGroupClass="col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-4 image-row"
              :imgSrc="agentImg"
              imgClass="downline-upload-img"
              :imageSource="personalImgSource"
            />

            <input-image
              @deleteImage="
                deleteImage('business', () => removeImageRef('business'))
              "
              ref="businessLogo"
              labelFor="business_logo"
              labelName="Business Logo Image"
              :vmodel.sync="businessLogo"
              formGroupClass="col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-4 image-row"
              :imgSrc="businessImage"
              imgClass="downline-upload-img"
              :imageSource="businessImgSource"
            />
          </div>
          <downline-rep-personal-address-content
            v-if="personalAddresses"
            :addresses="personalAddresses"
          />

          <div class="row">
            <div class="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
              <button type="submit" class="univ-btn">
                {{ isUpdate ? "Updating..." : "Update" }}
              </button>
            </div>
          </div>
        </form>



        <DownlineRepOtpVerification
    v-if="showOtpModal"
    v-model="showOtpModal"
    :identifier="contactInfo"
    :identifierTypeText="otpType"
    @save="handleVerificationResult"
    @close="closeOtpModal"
/>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import Api from "@/resource/Api";
import ApiSendOtp from "@/resource/BaseApi";
import Helper from "@/resource/Helper";
import DownlineRepPersonalAddressContent from "@/views/DownlineRep/detail/partials/DownlineRepPersonalAddressContent.vue";
import DownlineRepOtpVerification from "@/views/DownlineRep/Nuera/DownlineOTPNuera.vue";

export default {
  name: "DownlineRepPersonalInfo",
  components: {
    DownlineRepPersonalAddressContent,
    DownlineRepOtpVerification,
  },
  props: {
    agentImg: {
      required: true,
    },
    personalInfo: {
      required: true,
    },
    tabIndex: {
      required: true,
    },
    businessImage: {
      required: false,
    },
  },
  data: () => ({
    form: {
      agent_id: "",
      first_name: "",
      middle_name: "",
      last_name: "",
      cell_phone: "",
      fax: "",
      telephone: "",
      num_800: "",
      email: "",
    },
    contactInfo: null,
    otpType: null,
    showOtpModal: false,
    skipEmailVerification: false,
    skipPhoneVerification: false,
    emailVerified: false,
    phoneVerified: false,
    image: null,
    personalAddresses: [],
    states: Helper.getStates(),
    isUpdate: false,
    businessLogo: null,
    businessLogoSrc: null,
    personalImageSource: "",
    businessImageSource: "",
    downlineRepId: null,
    showOtpSectionEmail: false,
    showOtpSectionPhone: false,
    phoneMsg: false,
    emailMsg:false,
    emailValidationMessage: null,
    phoneValidationMessage: null,
    skipValidation: false, //this is for skip validation payload
    
  }),
  computed: {
    personalImgSource() {
      return this.personalImageSource;
    },
    businessImgSource() {
      return this.businessImageSource;
    },
    businessImageData() {
      return this.businessImage;
    },
  },
  methods: {
 onlyAllowDigits(event) {
    const char = String.fromCharCode(event.which);
    if (!/[0-9]/.test(char) || this.form.phone.length >= 10) {
      event.preventDefault();


        if (this.form.phone.length >= 10) {
    event.preventDefault();
  }
    }
  },

    resetValidationState() {
      this.validationStatus = null;
      this.emailValidationMessage = null;
      this.phoneValidationMessage = null;
      this.emailMsg = false;
      this.phoneMsg = false;
      this.showOtpSectionEmail = false;
      this.showOtpSectionPhone = false;
      this.skipEmailVerification = false;
      this.skipPhoneVerification = false;
      this.emailVerified = false;
      this.phoneVerified = false;
 



   
    },

    handleVerificationResult(result) {
    if (result.verified) {
      // Handle successful verification
      if (result.type === 'email') {
        this.emailmsg = true;
        this.emailVerified = true;
        this.emailValidationMessage = {
          type: 'success',
          title: 'Success',
          message: 'Your email has been verified!'
        };
        this.showOtpSectionEmail = false;
      } else if (result.type === 'phone') {
        this.phoneMsg = true;
        this.phoneVerified = true;
        this.phoneValidationMessage = {
          type: 'success',
          title: 'Success',
          message: 'Your phone has been verified!'
        };
        this.showOtpSectionPhone = false;
      }
      this.$notify('Verification successful!');
    } 
    else if (result.skipped) {
      // Handle skipped verification
      if (result.type === 'email') {
        this.skipEmailVerification = true;
        this.emailMsg = true;
        this.emailValidationMessage = {
          type: 'success',
          title: 'Success',
          message: 'Email verification was skipped'
        };
        this.showOtpSectionEmail = false;
      } else if (result.type === 'phone') {
        this.skipPhoneVerification = true;
        this.phoneMsg = true;
        this.phoneValidationMessage = {
          type: 'success',
          title: 'Success',
          message: 'Phone verification was skipped'
        };
        this.showOtpSectionPhone = false;
      }
      this.$notify('Verification skipped', 'warning');
    }
  },


  // method to send the otp
  async sendOtp() {

    // this.$notify(this.contactInfo);
    // this.$notify(this.otpType);

      try {
        const response = await ApiSendOtp.post('api/v2/send-common-otp', {
          contact: this.contactInfo,
          type: this.otpType,


        
        });

       
        
        if (response.data.success === true || response.data.status === 'success') {
      this.$notify('OTP sent successfully!');
    } else {
      this.$notify(response.data.message || 'Failed to send OTP. Please try again.', 'error');
      // this.showOtpSection = false;
    }
      } catch (error) {
        this.$notify('Failed to send OTP. Please try again.', 'error');
        // this.showOtpSection = false;
        console.error('OTP send error:', error);
      }
    },


    // to check if to skip the validation or not in the payload
   


    // this is method to update the information

    async updateInfo() {

    // this.resetValidationState();
    this.emailValidationMessage = null;
    this.phoneValidationMessage = null;
    this.emailMsg = false;
    this.phoneMsg = false;
    this.showOtpSectionEmail = false;
    this.showOtpSectionPhone = false;


      this.isUpdate = true;

            const url = `v3/update-agent-personal`;
      let loader = this.$loading.show();

      let formData = new FormData();
      for (const [key, value] of Object.entries(this.form)) {
        if (value) {
          formData.append(key, value);
        }
      }

      const biz_image = await this.updateBusinessImage();
      formData.append("agent_id", this.downlineRepId);
      const personalInformation = Object.assign(
        {},
        ...[...formData.entries()].map(([key, value]) => ({ [key]: value }))
      );

      const data  = {
        ...personalInformation,
        skip_validation_phone: this.skipPhoneVerification || this.phoneVerified,
        skip_validation_email: this.skipEmailVerification || this.emailVerified,
        no_attempt_limit:1,
         expiry_duration:600,
      }

        if(biz_image) {
          data.biz_image = biz_image;
        }

        await  Api.post(url, data).then((res) => {
           if(res.data.status==="success"){

            this.$notify(res.data.message);
            this.skipEmailVerification = false;
            this.skipPhoneVerification = false;
            this.resetValidationState();

           }
          
        
          if (this.businessLogo) {
            this.$emit("onSuccess", {
              businessImage: true,
              businessImageCallback: () => this.setImageSource("business"),
            });
            this.businessLogo = null;
          }
        })
        .catch((err) => {
          if(err.response.data.message.includes("cell phone is invalid - Validated using ClearoutPhone")){

            
            this.$notify("phone number is invalid! Please validate via OTP", "error");

            this.phoneMsg=true;
            this.showOtpSectionPhone=true;

            this.phoneValidationMessage = {
            type: 'error',
            title: 'Caution',
            message:'Invalid phone. Please validate via OTP'
            
          };
          }
          else if(err.response.data.message.includes("Email is invalid - Validated using Neverbounce API")|| 
          err.response.data.message.includes("Invalid email.")){

            this.$notify("Email is invalid! Please validate via OTP", "error");

            this.emailMsg=true;
            this.showOtpSectionEmail=true;
         

            this.emailValidationMessage={
              type:'error',
              title:'Caution',
              message:'Invalid email. Please validate via OTP'
            };


          }
          else if(err.response.data.message.includes("Both phone and email are invalid.")){
            this.$notify(err.response.data.message + " Please validate via OTP", "error");

            this.phoneMsg=true;
            this.showOtpSectionPhone=true;

            this.emailMsg=true;
            this.showOtpSectionEmail=true;

            this.phoneValidationMessage = {
              type: 'error',
              title: 'Caution',
              message:'Invalid phone. Please validate via OTP'
              
            };

            this.emailValidationMessage={
              type:'error',
              title:'Caution',
              message:'Invalid email. Please validate via OTP'
            };

          }

          else{
            this.$notify(err.response.data.message, "error");

          }


          // this.$notify(err.response.data.message, "error");


        })
        .finally(() => {
          this.isUpdate = false;
          loader.hide();
          this.$refs.observer.reset();
        });

      if (this.image) {
        const url = `v2/update-agent-image`;
        const formData = new FormData();
        formData.append("image", this.image);
        formData.append("type", "personal");
        formData.append("agent_id", this.downlineRepId);
        Api.post(url, formData)
          .then((res) => {
            this.$emit("onSuccess", {
              personalImage: true,
              personalImageCallback: () => this.setImageSource("personal"),
            });
            Api.notification(res.data.status, res.data.message);
            this.image = null;
          })
          .catch((err) => {
            Api.notification("error", err.response.data.message);
          });
      }
    },





    removeImageRef(type) {
      if (type === "personal") this.image = null;
      if (type === "business") {
        this.businessLogoSrc = null;                     
        this.businessLogo = null;
        this.businessImageSource = ""
      }
    },



    deleteImage(type, callback) {
      this.$emit("deleteImage", type, callback);
    },



    setImageSource(type) {
      if (type === "personal") this.personalImageSource = "server";
      if (type === "business") this.businessImageSource = "server";
    },



    async updateBusinessImage() {
      const formData = new FormData();
      if (this.businessLogo && (typeof this.businessLogo === File || typeof this.businessLogo === "object")) {
        formData.append("biz_image", this.businessLogo);
        const biz_image = formData.get("biz_image");

        const fileBuffer = await new Promise((resolve, reject) => {
          const fileReader = new FileReader();
          fileReader.onloadend = () => {
            resolve(fileReader.result);
          };

          fileReader.onerror = (error) => {
            reject(error);
          };

          fileReader.readAsDataURL(biz_image);
        });

        return fileBuffer;
      }
      return null;
    },


    // show otp modal
    
    openOtpModal(type) {
      if (type === "email" && !this.form.email) {
        this.$notify("Please enter an email address first.", "warning");
        return;
      }

      if (type === "phone" && !this.form.cell_phone) {
        this.$notify("Please enter a phone number first.", "warning");
        return;
      }

   

      if(type==="email"){
        this.contactInfo=this.form.email;
        this.otpType = type;
     this.sendOtp();

      }
      else{
        this.contactInfo=this.form.cell_phone;
        this.otpType = type;
     this.sendOtp();

      }
      // this.contactInfo = type === "email" ? this.form.email : this.form.cell_phone;
      this.showOtpModal = true;
      
    },

    closeOtpModal() {

      this.showOtpModal = false;
    },



  
  },
  watch: {
    personalInfo: function (value) {
      if (value) {
        this.form = {
          agent_id: value.agent_id,
          first_name: value.agent_fname,
          middle_name: value.agent_mname ? value.agent_mname : "",
          last_name: value.agent_lname,
          cell_phone: value.agent_phone1,
          fax: value.agent_fax,
          telephone: value.agent_phone2,
          num_800: value.agent_800,
          email: value.agent_email,
        };
        this.personalAddresses = value.address_list;
      }
    },
    businessImage: function (value) {
        if (value) this.businessLogo = value
    },

     "form.cell_phone": {
    handler(newVal, oldVal) {
      if (newVal !== oldVal) {
this.skipPhoneVerification = false;
        this.phoneVerified = false;
      }
    },
    immediate: true
  },
  "form.email": {
    handler(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.skipEmailVerification = false;
        this.emailVerified = false;

      }
    },
    immediate: true
  }

  },
  mounted() {
    this.downlineRepId = atob(this.$route.params.downlineRepId);
    this.$emit("onMounted", {
      personalImage: true,
      businessImage: true,
      personalImageCallback: () => this.setImageSource("personal"),
      businessImageCallback: () => this.setImageSource("business"),
    });
  },
};
</script>
<style>
.ai-location-wrapper {
  margin-top: 15px;
}
.ai-location-wrapper label {
  font-size: 16px !important;
  font-weight: bold;
}
.location-div {
  border: 2px solid #dce1e7;
  padding: 10px;
  border-radius: 6px;
}
.location-div p {
  display: inline-block;
  margin-bottom: 0;
}
.location-div button {
  float: right;
  margin-top: 3px;
  padding: 6px 12px;
  margin-right: 35px;
}
.location-div.primary-location {
  border: 2px solid #03c3ec;
}
.location-div.primary-location .primaryAdrs-btn {
  pointer-events: none;
}
.location-div.set-as-primary .primaryAdrs-btn {
  border: 2px solid #03c3ec;
  background-color: #fff;
  color: #03c3ec;
}
.location-div.set-as-primary .primaryAdrs-btn:hover {
  border: 2px solid #03c3ec;
  background-color: #03c3ec;
  color: #fff;
}
.fa-check-circle {
  color: #02bc77;
}
.fa-plus-circle {
  color: #03c3ec;
  font-size: 16px;
  margin-left: 3px;
  vertical-align: revert;
  margin-bottom: 5px;
}
.fa-exclamation-triangle {
  color: #f29423;
}

.location-div {
  position: relative;
}
.location-div .ai-delete-a {
  background: transparent linear-gradient(180deg, #0cf, #1597b8 49%, #0567bc);
  border-radius: 50px;
  width: 27px;
  height: 27px;
  color: #fff;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 10px 8px;
  position: absolute;
  right: 2px;
  top: 6px;
}
.form-ach .action-icons .primaryAdrs-btn {
  margin-right: 2px;
}
.form-ach .action-icons a {
  margin: 7px;
}
.uploaded {
  width: 100%;
  position: relative;
}
.upload-close-icon {
  max-width: 24px !important;
  max-height: 24px !important;
  position: absolute;
  /* top:1px; */
  margin-left: -14px;
}
.validate-via-otp-link{
  color: #03c3ec;
}

.rep-otp-validation {
  border: 2px solid #e31717;
  padding: 5px;
  padding-bottom: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: bold;
  width: 385px;
}

.rep-otp-validation:hover {
  border: 2px solid #a50e0e;
  box-shadow: #eb2a2a;
  background-color: aliceblue;
  cursor: pointer;
}

@media (max-width: 850px) and (min-width: 466px) {
  .location-div .primaryAdrs-btn {
    margin-right: 27px;
    padding: 6px 6px;
  }
  .location-div .ai-delete-a {
    margin: 10px 2px;
  }
}
@media (max-width: 465px) {
  .location-div .primaryAdrs-btn {
    padding: 6px 6px;
    float: none;
    margin-right: 0px !important;
    width: 80%;
    margin-top: 15px;
  }
  .location-div .ai-delete-a {
    top: unset !important;
    bottom: 5px;
  }
  .ai-image-wrapper .img-fluid {
    margin-right: 2px;
  }
  .ai-image-wrapper input {
    margin-left: 45px !important;
  }
  .ai-image-wrapper input::before {
    padding: 8px 10px;
    margin-right: -10px;
  }
  .downlineEdit-card {
    padding: 1rem;
  }
}
.uploaded {
  width: 104%;
}
</style>
